<template>
	<div>
		<div v-if="error" class="alert alert-danger">{{error}}</div>
		<template v-else-if="loaded">
			<template v-if="(this.$UserSession.hasPriv('TIMETABLE_VIEW_ALL') || this.$UserSession.hasPriv('TIMETABLE_ADMIN')) && student">
				<h1 ref="a">
					{{ student.displayName }}
					<button class="btn btn-outline-dark btn-sm" @click="setStudentAndTimetable">{{ $t('change') }}</button>
				</h1>
				<ul class="list-inline">
					<li class="list-inline-item">{{ $t('programme-colon') }} {{ $config.getProgrammeNameById(student.programme) }}</li>
					<li class="list-inline-item">{{ $t('year-colon') }} {{ $config.getUserYearStr(student) }}</li>
					<li class="list-inline-item">{{ $t('group-colon') }} {{ $config.getGroupNameById(student.group) }}</li>
					<li class="list-inline-item">{{ $t('firm-colon') }} {{ $config.getFirmNameById(student.firm) }}</li>
				</ul>
			</template>

			<IndividualTimetable
				:userId="student_id"
				:from="from"
				:until="until"
				:events="events"
				:bgEvents="bgEvents"
				@selectEvent="selectEvent"
			/>
		</template>

		<template v-else>
			<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n" />
		</template>

		<EventDetailsModal
			v-if="selectedEvent"
			v-model="modalVisible"
			:event="selectedEvent"
		/>
	</div>
</template>

<script>
import IndividualTimetable from 'src/components/Timetables/IndividualTimetable.vue';
import EventDetailsModal from 'src/components/Timetables/EventDetailsModal.vue';


export default {
	components: {
		IndividualTimetable,
		EventDetailsModal
	},
	data() {
		return {
			future: false,
			student_id: null,
			error: null,
			loaded: false,
			student : null,
			group: {},
			events: [],
			bgEvents: [],
			from: null,
			until: null,
			coords: {},
			modal: {},
			modalVisible: false,
			selectedEvent: null,
		}
	},
	mounted() {
		this.setStudentAndTimetable()
	},
	methods: {
		fetchTimetable() {
			this.from = null
			this.until = null
			this.loaded = false
			Promise.all([
				this.fetchEvents(),
				this.fetchBackgroundEvents(),
				this.getStudentDetails(),
			]).then(() => {
				this.loaded = true
			})
		},
		fetchEvents() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/events/all`, {
				method: 'GET',
				data: {
					user_id: this.student_id,
					tttimetable_id: this.$route.params.timetableid,	// Can be undefined
				}
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.events = res.results.map(event => {
					event.students = [{ id: this.student_id }]
					return event
				})
				this.from = res.from
				this.until = res.to
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
		},
		fetchBackgroundEvents() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/backgroundevents/all`, {
				method: 'GET',
				data: {
					user_id: this.student_id,
					tttimetable_id: this.$route.params.timetableid, // Can be undefined
				}
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.bgEvents = res.results
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
			})
		},
		setStudentAndTimetable() {
			if (
				!this.$UserSession.hasPriv.call(this, 'TIMETABLE_VIEW_ALL')
				&& !this.$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')
				&& this.$UserSession.hasPriv.call(this, 'APP_STUDENT')
			) {
				this.student_id = Number(this.$UserSession.getValue('id'))
				this.getStudentDetails()
				this.fetchTimetable()
				return
			}

			if (
				!this.$UserSession.hasPriv.call(this, 'TIMETABLE_VIEW_ALL')
				&& !this.$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')
			) return

			if (this.$route.params.studentid) {
				this.student_id = Number(this.$route.params.studentid)
				this.getStudentDetails()
				this.fetchTimetable()
			}

			else this.$users.getStudents.call(this).then(students => {
				const self = this

				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function(selection) {
						self.$store.commit("closeModal")
						self.student_id = Number(selection.id)
						self.fetchTimetable()
					},
					selected: [],
					data: students,
					captionKey: "displayName",
					studentSearchFilters: true
				})
			})
		},
		getStudentDetails() {
			return this.$users.getUserById.call(this, this.student_id).then(student => {
				this.student = student;
			})
		},
		selectEvent(event) {
			this.selectedEvent = event;
			this.modalVisible = true;
			// Fetch additional details for timetable events, but NOT background events
			if(event.ttsessiontype_id){
				return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/events/get`, {
					method: 'GET',
					data: {
						id: this.selectedEvent.id,
					}
				}).then(res => {
					if (res.status == 'SUCCESS'){
						this.selectedEvent = {
							...this.selectedEvent,
							...res.result
						}
					}
				}).catch(err => {
					this.$log.error.call(this, err)
				})
			} else {
				return true;
			}
		},
	},
}
</script>
